<template>
<div>
    <div v-if="ie=='i'">
        <!-- 莱索托(LSO)进口提单明细 -->
        <el-card class="partItem">
            <table>
                <tbody>
                    <tr>
                        <th width="25%">入关号</th>
                        <td width="25%">{{billInfo.EntryNumber}}</td>
                        <th width="25%">报关编号</th>
                        <td width="25%">{{billInfo.AgentId}}</td>
                    </tr>
                    <tr>
                        <th>代理报关</th>
                        <td>{{billInfo.AgentName}}</td>
                        <th>进口商ID</th>
                        <td>{{billInfo.ImporterId}}</td>
                    </tr>
                    <tr>
                        <th>净重</th>
                        <td>{{billInfo.NetWeight}} {{billInfo.NetWeightUnit}}</td>
                        <th>美元金额</th>
                        <td>{{billInfo.Value}} {{billInfo.ValueUnit}}</td>
                    </tr>
                    <tr>
                        <th>总金额（莱索托洛蒂）</th>
                        <td>{{billInfo.TotalLSLValue}} {{billInfo.TotalLSLValueUnit}}</td>
                        <th>税额（莱索托洛蒂）</th>
                        <td>{{billInfo.TaxAmountLSL}} {{billInfo.TaxAmountLSLUnit}}</td>
                    </tr>
                </tbody>
            </table>
        </el-card>

        <el-card class="partItem">
            <div slot="header">
                <span class="headTitle">运输信息</span>
            </div>
            <table>
                <tbody>
                    <tr>
                        <th width="25%">原产国</th>
                        <td width="25%">{{billInfo.Country}}</td>
                        <th width="25%">包装类型</th>
                        <td width="25%">{{billInfo.QuantityUnit}}</td>
                    </tr>
                    <tr>
                        <th>卸货港代码</th>
                        <td>{{billInfo.EntryPortCode}}</td>
                        <th>装货港代码</th>
                        <td>{{billInfo.ExitPortCode}}</td>
                    </tr>
                    <tr>
                        <th>运输方式</th>
                        <td colspan="3">{{billInfo.Transport}}</td>
                    </tr>
                </tbody>
            </table>
        </el-card>
    </div>
    <div v-if="ie=='e'">
        <!-- 莱索托(LSO)出口提单明细 -->
        <el-card class="partItem">
            <table>
                <tbody>
                    <tr>
                        <th width="25%">净重</th>
                        <td width="25%">{{billInfo.NetWeight}} {{billInfo.NetWeightUnit}}</td>
                        <th width="25%">美元金额</th>
                        <td width="25%">{{billInfo.Value}} {{billInfo.ValueUnit}}</td>
                    </tr>
                    <tr>
                        <th>总金额（莱索托洛蒂）</th>
                        <td>{{billInfo.TotalLSLValue}} {{billInfo.TotalLSLValueUnit}}</td>
                        <th>税额（莱索托洛蒂）</th>
                        <td>{{billInfo.TaxAmountLSL}} {{billInfo.TaxAmountLSLUnit}}</td>
                    </tr>
                </tbody>
            </table>
        </el-card>

        <el-card class="partItem">
            <div slot="header">
                <span class="headTitle">运输信息</span>
            </div>
            <table>
                <tbody>
                    <tr>
                        <th width="25%">原产国</th>
                        <td width="25%">{{billInfo.OriginCountry}}</td>
                        <th width="25%">目的国</th>
                        <td width="25%">{{billInfo.Country}}</td>
                    </tr>
                    <tr>
                        <th>包装类型</th>
                        <td colspan="3">{{billInfo.QuantityUnit}}</td>
                    </tr>
                </tbody>
            </table>
        </el-card>
    </div>
</div>
</template>

<script>
export default {
    props:["billInfo","ie"],
    data() {
        return {

        };
    },
    methods: {
        
    },
    mounted() {

    },
};
</script>

<style lang="scss" scoped>
.partItem {
    margin-bottom: 20px;
    ::v-deep .el-card__header {
        padding: 10px 20px;
        .headTitle {
            display: inline-block;
            padding-left: 10px;
            font-size: 14px;
            border-left: 2px solid var(--themeColor);
            font-weight: bold;
        }
    }
}
table {
    width: 100%;
    border-collapse: collapse;
    tr {
        display: table-row;
        vertical-align: inherit;
        border-color: inherit;
        th,
        td {
            font-size: 12px;
            color: #666;
            height: 40px;
            border: 1px solid #eaeaea;
            text-align: center;
        }
        th {
            background-color: #f5f7fa;
            font-weight: 700;
        }
        .bg {
            background-color: var(--themeColor);
            color: #fff;
            font-weight: 700;
            opacity: 0.8;
        }
    }
}
</style>